module.exports = __webpack_public_path__ + "img/card3.0f42da42.png";